class QuickViewDrawer extends HTMLElement {
    constructor() {
        super();
        this.triggerElement = null;
        this.dataContainer = null;
        this.loadingSpinner = null;
        this.button = null;
    }
    connectedCallback() {
        this.container = document.querySelector('.quick-view-drawer__container')
        this.overlay = document.querySelector('.quick-view-drawer__overlay')
        this.content = document.querySelector('.quick-view-drawer__content')
        this.bindEvents();
    }
    
    bindEvents() {
        // Listen for trigger buttons anywhere on the page
       document.addEventListener('click', (e) => {
            const trigger = e.target.matches('[data-quick-view]') 
                ? e.target 
                : e.target.closest('[data-quick-view]');
                
            if (trigger) {
                e.preventDefault();
                this.triggerElement = trigger; // Store the actual button clicked
                // Find the parent container with data attributes
                this.dataContainer = trigger.closest('.recommended-products__product__data.productClick');
                this.open();
            }
        });
        
        const closeBtn = document.querySelector('.quick-view-drawer__header .close-drawer');
        if (closeBtn) {
            closeBtn.addEventListener('click', () => this.close());
        }
        
        // Overlay click to close
        if (this.overlay) {
            this.overlay.addEventListener('click', () => this.close());
        }
        
        // ESC key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') this.close();
        });
    }
    
    open() {
        this.renderContents();
        this.storeSliderPositions();

        if (this.container) this.container.classList.add('drawer-open');
        if (this.overlay) this.overlay.style.display = 'block';
        document.body.style.overflow = 'hidden';
    }
    
    close() {
        if (this.container) this.container.classList.remove('drawer-open');
        if (this.overlay) this.overlay.style.removeProperty('display');
        document.body.style.overflow = '';
        
        requestAnimationFrame(() => this.restoreSliderPositions());
    }

    storeSliderPositions() {
        this.sliderPositions = [];
        const sliders = document.querySelectorAll('slider-component-laurajames [id^="Slider-"]');
        sliders.forEach(slider => {
            this.sliderPositions.push({
                element: slider,
                scrollLeft: slider.scrollLeft
            });
        });
    }

    restoreSliderPositions() {
        if (!this.sliderPositions) return;
        
        this.sliderPositions.forEach(({ element, scrollLeft }) => {
            if (element) {
                element.scrollLeft = scrollLeft;
            }
        });
    }

    handleAddToCart(event) {
        if (this.button && this.button.disabled) {
            return;
        }

        if (!this.loadingSpinner || !this.button) return;

        this.loadingSpinner.classList.remove('hidden');
        this.button.disabled = true;

        // Get product tags and calculate lowest delivery cost
        const productTags = this.dataContainer?.dataset.tags;
        const lowestDeliveryCost = productTags && typeof delivery_tabs !== 'undefined' ? 
            delivery_tabs.calculateLowestDeliveryCost(productTags) : null;
        
        // Build properties object
        const properties = {};
        
        // Add lowest delivery cost if available
        if (lowestDeliveryCost !== null) {
            properties['Lowest Delivery Cost'] = String(lowestDeliveryCost);
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
            id: this.button.dataset.variant_id,
            quantity: 1,
            properties: properties
        })
        })
        .then(res => {
            if (!res.ok) {
                throw new Error(`HTTP error! status: ${res.status}`);
            }
            return res.json();
        })
        .then(data => {
            // console.log('Cart updated:', data);
            this.handleCartSuccess();
        })
        .catch(error => {
            // console.error('Error adding to cart:', error);
            this.resetUI();
        });
    }

    handleCartSuccess() {
        // Publish cart update event
        if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartUpdate, { 
                source: 'product-quick-view-drawer'
            });
        }

        document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { source: 'product-quick-view-drawer' }
        }));

        // Wait for cart recommendations to be updated
        document.addEventListener('cart:recommendations-updated', () => {
            this.resetUI();
            this.openCartAndCloseDrawer();
        },{ once: true });
    }

    openCartAndCloseDrawer() {
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cart) {
            if (typeof cart.refresh === 'function') {
                cart.refresh(true);
            }
        }

        const overlay = document.querySelector('.quick-view-drawer__overlay');
        const drawer = document.querySelector('.quick-view-drawer__container.drawer-open');
        
        if (overlay) {
            overlay.style.removeProperty('display');
        }
        if (drawer) {
            drawer.classList.remove('drawer-open');
        }

        document.body.style.overflow = '';
        
        requestAnimationFrame(() => this.restoreSliderPositions());
    }

    resetUI() {
        if (this.loadingSpinner) {
            this.loadingSpinner.classList.add('hidden');
        }
        if (this.button) {
            this.button.disabled = false;
        }
    }

    renderContents() {
        if (!this.dataContainer) return;

        const productTitle = this.dataContainer.dataset.item_name;
        const words = productTitle.split(' ');
        const title = words[0];
        const subtitle = words.slice(1).join(' ');
        const productImage = this.dataContainer.dataset.image;
        const productPrice = this.dataContainer.dataset.price;
        const productCompareAtPrice = this.dataContainer.dataset.compare_at_price;
        const productAvailability = this.dataContainer.dataset.available;
        const productHandle = this.dataContainer.dataset.handle;
        const productVariantId = this.dataContainer.dataset.variant_id;
        const productUsp1 = this.dataContainer.dataset.usp1 || '';
        const productUsp2 = this.dataContainer.dataset.usp2 || '';
        const productUsp3 = this.dataContainer.dataset.usp3 || '';
        const productHasFreegift = this.dataContainer.dataset.has_freegift || false; 
        const productHasFreefurniturecover = this.dataContainer.dataset.has_freefurniturecover || false;
        const productTags = this.dataContainer.dataset.tags;
        let deliveryDate = '';
        const productParasolHandles = this.dataContainer.dataset.parasol_handles || '';
        const productHasParasolDate = this.dataContainer.dataset.has_parasol_date || '';
        const justInBadgeMode = window.normalizeJustInBadgeMode(
            this.dataContainer.getAttribute('data-just_in_badge_mode') ||
            this.dataContainer.dataset.justInBadgeMode
        );
        const customBadgeEnabled = window.normalizeCustomBadgeEnabled(
            this.dataContainer.getAttribute('data-enable_custom_badge') ||
            this.dataContainer.dataset.enableCustomBadge
        );
        const publishedAt =
            this.dataContainer.getAttribute('data-published_at') ||
            this.dataContainer.dataset.publishedAt ||
            '';
        const productParasolBaseHandle = this.dataContainer.dataset.parasol_base_handle || '';

        // Helper function to add commas to numbers
        const addCommas = (num) => {
            return parseFloat(num).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        };

        // Parse price and compare at price to number
        const formattedPrice = formatMoney(addCommas(+productPrice));
        const formattedComparePrice = productCompareAtPrice ? formatMoney(addCommas(+productCompareAtPrice)) : null;

        // Check if product is available and has pre-order tag
        let preorderProduct = false;
        if (productAvailability === 'true') {
            if (productTags) {
                const tagsArray = productTags.split(',');
                preorderProduct = tagsArray.some(tag => tag.trim().includes('meta-pre-order:'));
            }
        }

        const getDeliveryDate = window._shipping.calculateDateRangeForProduct(productTags);
        let setMaxDeliveryDate = null;
        if (getDeliveryDate.success) {
            deliveryDate = getDeliveryDate.dateRangeString;
            setMaxDeliveryDate = getDeliveryDate.maxDeliveryDate;
        }

        // Check if product has parasol delivery date
        if(productHasParasolDate == "true" && productParasolHandles) {
            const parasolHandles = productParasolHandles.split(',');
            
            // Find handle without parasol
            const selectedHandle = parasolHandles.find(handle => 
                handle.trim().includes('no-parasol') || !handle.trim().includes('parasol')
            );

            if(selectedHandle) {
                fetch(`/products/${selectedHandle.trim()}.json`)
                    .then(response => response.json())
                    .then(data => {
                        // Remove spaces after commas in product tags
                        const cleanedTags = data.product.tags.replace(/,\s+/g, ',');
                        const result = window._shipping.calculateDateRangeForProduct(cleanedTags);
                        if (result.success) {
                            // Check if parasol should be shown based on 14-day rule
                            const shouldShowParasolDate = !setMaxDeliveryDate || 
                                                          window._shipping.getDaysDifference(result.minDeliveryDate, setMaxDeliveryDate) >= 14;
                            
                            // Update delivery date display
                            const deliveryContainer = this.querySelector('.quick-view-drawer-date__container');
                            if (deliveryContainer) {
                                if (shouldShowParasolDate) {
                                    deliveryContainer.innerHTML = `
                                        Furniture Delivered by ${deliveryDate} <br>
                                        Parasol Delivered by ${result.dateRangeString}
                                    `;
                                } else {
                                    deliveryContainer.innerHTML = `Get it by ${deliveryDate}`;
                                }
                            }
                        }
                    })
                    .catch(error => console.error('Error fetching parasol product:', error));
            }
        }

        // Check if product has parasol base delivery date
        if(productParasolBaseHandle) {
            fetch(`/products/${productParasolBaseHandle.trim()}.json`)
                .then(response => response.json())
                .then(data => {
                    const cleanedTags = data.product.tags.replace(/,\s+/g, ',');
                    const result = window._shipping.calculateDateRangeForProduct(cleanedTags);
                    if (result.success) {
                        // Update delivery date display - append parasol base
                        const deliveryContainer = this.querySelector('.quick-view-drawer-date__container');
                        if (deliveryContainer) {
                            const currentHtml = deliveryContainer.innerHTML;
                            deliveryContainer.innerHTML = currentHtml + ` <br>Parasol Base Delivered by ${result.dateRangeString}`;
                        }
                    }
                })
                .catch(error => console.error('Error fetching parasol base product:', error));
        }


        let badgeMessage = ''; // Default message
        const badgeMessages = {
            'isEOL': 'Discontinued',
            'status:OnHold': 'Sold out',
            'status:Outlet': 'Sold out',
            'seasonal': 'Sold for season'
        };

        // Check if the inventory is unavailable
        if ((productAvailability == false || productAvailability == 'false')) {
            // Find the first matching tag in the dictionary
                badgeMessage = 'Back Soon'; // Default message
                for (const [tag, message] of Object.entries(badgeMessages)) {
                if (item.productTags && item.productTags.includes(tag)) {
                    badgeMessage = message;
                    break; // Exit loop after finding the first match
                }
            }
        }
                

        let discount = 0;
        if(productCompareAtPrice && productCompareAtPrice !== '0.0') {
            discount = Math.round(parseFloat(productCompareAtPrice) - parseFloat(productPrice));
        }

        // fetch large size product image
        const drawerImage = productImage.replace(/\.(jpg|jpeg|png|gif|webp)/, '_large.$1');

        this.content.innerHTML = `<div class="quick-view-drawer__product-title">
                <p class="h1">${title}</p>
                ${(() => {
                    const reviewsCount = parseInt(this.dataContainer.dataset.reviews_count) || 0;
                    const ratingValue = parseFloat(this.dataContainer.dataset.average_rating) || 0;
                    const maxStars = 5;
                    
                    return reviewsCount > 5 ? `
                        <div class="stars-section">
                            <div class="stars-wrapper">
                                ${Array.from({length: maxStars}, (_, i) => {
                                    const starPosition = i;
                                    const remainingRating = ratingValue - starPosition;
                                    
                                    let fillPercentage;
                                    if (remainingRating <= 0) {
                                        fillPercentage = 0;
                                    } else if (remainingRating >= 1) {
                                        fillPercentage = 100;
                                    } else {
                                        fillPercentage = remainingRating * 100;
                                    }
                                    
                                    return `
                                        <div class="star-wrapper">
                                            <span class="star-empty">★</span>
                                            <span class="star-filled" style="width: ${fillPercentage}%;">★</span>
                                        </div>
                                    `;
                                }).join('')}
                            </div>
                            <span class="rating-score">${ratingValue.toFixed(1)}</span>
                        </div>
                    ` : '';
                })()}
            </div>
            <div class="quick-view-drawer__product-subtitle">
                <p>${subtitle}</p>
            </div>
            <div class="quick-view-drawer__product-image">
                <a href="/products/${productHandle}" class="quick-view-drawer__link"></a>
                <div class="quick-view-drawer__product-image-placeholder">
                    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" style="opacity: 0.3;">
                        <rect width="100" height="80" rx="4" fill="#ccc"/>
                        <circle cx="30" cy="25" r="8" fill="#bbb"/>
                        <path d="M10 60 L30 45 L50 55 L70 40 L90 50 L90 80 L10 80 Z" fill="#bbb"/>
                    </svg>
                </div>
            
                <img src="${drawerImage}" width="400" alt="${productTitle}" loading="lazy"
                   onload="this.style.opacity='1'; this.parentElement.querySelector('.quick-view-drawer__product-image-placeholder').style.opacity='0';"
                   onerror="this.style.opacity='1'; this.parentElement.querySelector('.quick-view-drawer__product-image-placeholder').style.opacity='0';"
                >
                <div class="recommended-products__product-badges">
                    ${this.freeItemSnippet(productHasFreefurniturecover,productHasFreegift, productAvailability)}
                    ${typeof window.customBadgeSnippet === 'function'
                        ? window.customBadgeSnippet(customBadgeEnabled)
                        : ''
                    }
                    ${typeof window.justInBadgeSnippet === 'function'
                        ? window.justInBadgeSnippet(justInBadgeMode, publishedAt, undefined, customBadgeEnabled)
                        : ''
                    }
                </div>
            </div>
            <div class="quick-view-drawer__product-info">
                <div class="quick-view-drawer__product-price-container">
                    <div class="quick-view-drawer__product-price">
                        <div class="quick-view-drawer__product-price ${productCompareAtPrice && productCompareAtPrice !== '0.0' ? 'price--sale' : ''}">
                            ${productCompareAtPrice && productCompareAtPrice !== '0.0' ? 
                                `<span class="regular-price">${formattedComparePrice}</span><span class="sale-price">${formattedPrice}</span>` 
                                : 
                                `<span class="regular-price">${formattedPrice}</span>`
                            }
                        </div>
                        <div class="quick-view-drawer__product-badge">
                            ${discount ? 
                                `<span class="badge badge--sale">Save ${formatMoney(discount)}</span>`
                                : ''   
                            }
                            ${productAvailability === true || productAvailability === 'true' ?
                                (!preorderProduct ? 
                                    `<span class="badge badge--available">Ready to Deliver</span>`
                                    : ''
                                )
                                : ''
                            }
                        </div>
                    </div>
                </div>  
                <div class="quick-view-drawer__product-usp">
                    ${this.dataset.showUspList === 'true' && (productUsp1 || productUsp2 || productUsp3) ? 
                        `<ul class="quick-view-drawer__product-usp-list">
                            ${productUsp1 ? `<li><span>${productUsp1}</span></li>` : ''}
                            ${productUsp2 ? `<li><span>${productUsp2}</span></li>` : ''}
                            ${productUsp3 ? `<li><span>${productUsp3}</span></li>` : ''}
                        </ul>` 
                        : ''
                    }
                    <a href="/products/${productHandle}" class="quick-view-drawer__product-usp__button drawer-button" data-title="description" data-section-id="description-section">
                        <span class="svg-wrapper">
                            <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.458984 6.0001C0.458984 6.0001 2.29232 2.33344 5.50065 2.33344C8.709 2.33344 10.5423 6.0001 10.5423 6.0001C10.5423 6.0001 8.709 9.66674 5.50065 9.66674C2.29232 9.66674 0.458984 6.0001 0.458984 6.0001Z" fill="#D9D9D9" stroke="#304E3E"/>
                            <path d="M0.458984 6.0001C0.458984 6.0001 2.29232 2.33344 5.50065 2.33344C8.709 2.33344 10.5423 6.0001 10.5423 6.0001C10.5423 6.0001 8.709 9.66674 5.50065 9.66674C2.29232 9.66674 0.458984 6.0001 0.458984 6.0001Z" fill="#304E3E" stroke="#304E3E"/>
                            <path d="M0.458984 6.0001C0.458984 6.0001 2.29232 2.33344 5.50065 2.33344C8.709 2.33344 10.5423 6.0001 10.5423 6.0001C10.5423 6.0001 8.709 9.66674 5.50065 9.66674C2.29232 9.66674 0.458984 6.0001 0.458984 6.0001Z" fill="#304E3E" stroke="#304E3E" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M5.49935 7.83323C6.51186 7.83323 7.33268 7.01242 7.33268 5.9999C7.33268 4.98738 6.51186 4.16656 5.49935 4.16656C4.48682 4.16656 3.66602 4.98738 3.66602 5.9999C3.66602 7.01242 4.48682 7.83323 5.49935 7.83323Z" fill="#304E3E" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                        <span>
                            View Full Product Overview
                        </span> 
                    </a>
                </div>
                ${productAvailability === 'true' && deliveryDate ? `
                    <div class="quick-view-drawer__delivery-date ${preorderProduct ? 'preorder' : ''}">
                        <span class="svg-wrapper ${!preorderProduct ? 'glow-icon' : ''}">
                            <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                            <rect width="10" height="10" rx="5" fill="#58856D"/>
                            <rect width="10" height="10" rx="5" fill="#58856D" fill-opacity="0.75"/>
                            </svg>
                        </span> 
                        <p class="product-delivery-date__text" data-has_parasol_date="${productHasParasolDate}">
                            <span class="instock-label">
                            ${preorderProduct ? window.shopifyTranslations.pre_order : window.shopifyTranslations.in_stock}
                            </span>
                            <span class="quick-view-drawer-date__container">
                                ${productHasParasolDate === 'true' || productParasolBaseHandle ? 'Furniture Delivered by' : 'Get it by'} ${deliveryDate}
                            </span>
                        </p>
                    </div>
                ` : `
                    <div class="quick-view-drawer__delivery-date">
                        <span class="svg-wrapper">
                            <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                            <rect width="10" height="10" rx="5" fill="#CE6755"/>
                            <rect width="10" height="10" rx="5" fill="#CE6755" fill-opacity="0.75"/>
                            </svg>
                        </span> 
                        <p class="product-delivery-date__text">
                            Out of Stock
                        </p>
                    </div>
                `}
                <div class="quick-view-drawer__buttons add-to-cart-button">
                    <button class="button--dark add-to-cart" data-variant_id="${productVariantId}"  ${productAvailability !== 'true' ? 'disabled': ''}>
                    <span>ADD TO CART</span>
                    <div class="loading__spinner hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>
                    </div>
                    </button>
                </div>
                ${this.dataset.showFullProductInfo === 'true' ? `
                <div class="quick-view-drawer__buttons">
                    <a href="/products/${productHandle}" class="full-product-info button--grey">Full Product Info</a>
                </div>
                ` : ''}
            </div>`
        
        // Add click event listener to the add to cart button when the product is available
        if(productAvailability === 'true') {
            this.button = this.querySelector('button.add-to-cart')
            this.loadingSpinner = this.querySelector('.add-to-cart .loading__spinner')
            this.button.addEventListener('click', (event) => this.handleAddToCart(event));
        }

        //Add event listener toView All Product Overview button && Full Product Info Button after render contents
        const viewFullProductButton = this.querySelector('.quick-view-drawer__product-usp__button')
        const fullProductInfoButton = this.querySelector('.quick-view-drawer__buttons .full-product-info')

        viewFullProductButton.addEventListener('click', (event) => this.handleSaveRecentlyViewed(event))
        if (fullProductInfoButton) {
            fullProductInfoButton.addEventListener('click', (event) => this.handleSaveRecentlyViewed(event))
        }
    }

    freeItemSnippet(hasFreeFurnitureCover, hasFreeGift, inventoryAvailable){
        let label = '';
        if(!inventoryAvailable) return ''

        if (hasFreeGift && hasFreeGift === 'true') {
            alert(hasFreeGift)
            label = 'Free Gift';
        } else if (hasFreeFurnitureCover && hasFreeFurnitureCover === 'true') {
            label = 'Free Furniture Cover';
        }

        if(label) {
            return `      
            <div class="free-item-badge badge--free">
                <div class="free-item-badge__icon-container">
                    <svg width="10" height="10" viewBox="0 0 7 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.18513 1.12744L6.18651 1.12562C6.30542 0.988499 6.36447 0.810207 6.35065 0.629967C6.33684 0.449727 6.2513 0.282303 6.11286 0.164528C6.04431 0.106212 5.96483 0.0618401 5.87897 0.0339457C5.7931 0.00605126 5.70253 -0.00481918 5.61242 0.00195498C5.43045 0.015636 5.26141 0.100357 5.1425 0.23748L2.4143 3.3178L1.56165 2.47284C1.49774 2.40954 1.42186 2.35932 1.33836 2.32507C1.25486 2.29081 1.16536 2.27318 1.07498 2.27318C0.984592 2.27318 0.895094 2.29081 0.811591 2.32507C0.728088 2.35932 0.652215 2.40954 0.588305 2.47284C0.524394 2.53614 0.473697 2.61128 0.439109 2.69399C0.404521 2.7767 0.386719 2.86534 0.386719 2.95486C0.386719 3.04438 0.404521 3.13302 0.439109 3.21573C0.473697 3.29844 0.524394 3.37358 0.588305 3.43688L1.96457 4.80046C2.09719 4.93227 2.27433 5.00045 2.46936 5H2.47808C2.57273 4.99635 2.6656 4.9734 2.75088 4.93257C2.83616 4.89175 2.91202 4.83393 2.9737 4.76274L6.18513 1.12744Z" fill="#D9D9D9"/>
                </svg>
                </div>
                <span>
                    ${label}
                </span>
            </div>`;
        } else{
            return '';
        }
    }


    handleSaveRecentlyViewed(event) {
        event.preventDefault()
        if (typeof saveRecentlyViewed === 'function') {
            const productData = this.dataContainer.dataset;
            const productEl = this.dataContainer;
            const productItem = {
                title: productData.item_name,
                image: productData.image,
                price: productData.price,
                compare_at_price: productData.compare_at_price,
                url: productData.handle,
                product_id: productData.item_id,
                product_variant_id: productData.variant_id,
                tags: productData.tags,
                available: productData.available,
                objectID: '',
                has_freefurniturecover: productData.has_freefurniturecover,
                has_freegift: productData.has_freegift,
                usp1: productData.usp1 || '', 
                usp2: productData.usp2 || '',
                usp3: productData.usp3 || '', 
                average_rating: productData.average_rating || '',
                reviews_count: productData.reviews_count || '',
                parasol_handles: productData.parasol_handles || '',
                has_parasol_date: productData.has_parasol_date || '',
                just_in_badge_mode:
                    productEl.getAttribute('data-just_in_badge_mode') ||
                    productData.justInBadgeMode ||
                    'off',
                enable_custom_badge:
                    productEl.getAttribute('data-enable_custom_badge') ||
                    productData.enableCustomBadge ||
                    'false',
                published_at:
                    productEl.getAttribute('data-published_at') ||
                    productData.publishedAt ||
                    ''

            };
            saveRecentlyViewed(productItem);
        }

        //continue redirecting
        window.location.href = event.currentTarget.href;
    }
}

// Register the web component
customElements.define('quick-view-drawer', QuickViewDrawer);